import PropTypes from 'prop-types';
import { SelectGeneric } from 'ypf-pas-general-ui-components';

const ApproverFormSelect = ({ errors, isInvalid, name, onChange, options, value, isDisabled }) => (
  <SelectGeneric
    defaultValueOneOption={false}
    errors={errors}
    isDisabled={isDisabled}
    isInvalid={isInvalid}
    isMulti
    label="Aprobador o grupo"
    name={name}
    onChange={onChange}
    options={options}
    placeholder="Buscar por nombre o grupo"
    value={value}
    variantOptions="info"
    withSelect="100%"
  />
);

ApproverFormSelect.propTypes = {
  errors: PropTypes.bool.isRequired,
  isInvalid: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  options: PropTypes.objectOf({}).isRequired,
  value: PropTypes.objectOf({}).isRequired
};

export default ApproverFormSelect;
